import { unwrap, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createRoutinesApi(client) {
    async function list(query) {
        return unwrap(await client.GET('/v1/routines', { params: { query: query ?? {} } }));
    }
    return {
        list,
        iterate(query) {
            return paginate(list, query);
        },
        async get(id) {
            return unwrap(await client.GET('/v1/routines/{id}', { params: { path: { id } } }));
        },
        async create(body) {
            return unwrap(await client.POST('/v1/routines', { body }));
        },
        async replace(id, body) {
            return unwrap(await client.PUT('/v1/routines/{id}', { params: { path: { id } }, body }));
        },
        async remove(id) {
            unwrapVoid(await client.DELETE('/v1/routines/{id}', { params: { path: { id } } }));
        },
        async archive(id) {
            return unwrap(await client.POST('/v1/routines/{id}/archive', { params: { path: { id } } }));
        },
        async unarchive(id) {
            return unwrap(await client.POST('/v1/routines/{id}/unarchive', { params: { path: { id } } }));
        },
        async fork(id) {
            return unwrap(await client.POST('/v1/routines/{id}/fork', { params: { path: { id } } }));
        },
        async templates(query) {
            const list = unwrap(await client.GET('/v1/routine-templates', { params: { query: query ?? {} } }));
            return list.items;
        },
    };
}
//# sourceMappingURL=routines.js.map